import type { ComposerSubmit } from "../types";

export interface ComposerState {
  text: string;
  resolve: boolean;
  internal: boolean;
}

/** Что уходит в onSubmit; null, если отправлять нечего. Заметка не решает. */
export function composerPayload(state: ComposerState): ComposerSubmit | null {
  const text = state.text.trim();
  if (!text) return null;
  return {
    text,
    resolve: !state.internal && state.resolve,
    internal: state.internal,
  };
}

/** false от onSubmit (отправка не удалась) оставляет всё как было. */
export function composerAfterSubmit(
  state: ComposerState,
  ok: boolean | undefined
): ComposerState {
  if (ok === false) return state;
  return { ...state, text: "", resolve: false };
}

/** Галочка «и решить обращение» только у ответа в нерешённом обращении. */
export function showResolve({
  canResolve,
  internal,
}: {
  canResolve: boolean;
  internal: boolean;
}): boolean {
  return canResolve && !internal;
}
